<div
  class="modal-body new-patprize-modal text-center top-radious"
  *ngIf="content"
>
  <div
    id="header"
    class="display-flex-space-between flex-align-center header-title"
  >
    <div>
      {{ 'PATPRIZES.NewPrize' | translate }}
      <i
        *ngIf="
          defaultLanguage !== selectedLang && !content.item.library && !viewOnly
        "
        class="fas fa-language fa-1_5x pointer"
        tooltip="{{ 'Generic.TranslateFromDefault' | translate }}"
        placement="bottom"
        (click)="translate(content.item, selectedLang)"
      ></i>
    </div>

    <div *ngIf="viewOnly">&nbsp;</div>
    <i class="fa fa-2x fa-close pointer" (click)="bsModalRef.hide()"></i>
  </div>
  <div id="body">
    <div class="language-container">
      <app-language-selector
        *ngIf="!viewOnly"
        [languages]="content.languages"
        (onSelectLanguage)="changeLanguage($event)"
      ></app-language-selector>
    </div>

    <!--/// Hide To API ISSUE ///-->

    <div
      id="image"
      [class.pat-image]="getPatPrizeImage()"
      [ngStyle]="getPatPrizeImage()"
    >
      <div class="notHoverImage">
        <div class="file-selector">
          <input
            type="file"
            id="addImage"
            accept="image/*"
            capture="camera"
            (change)="onAddImage($event)"
          />
          <label class="pointer small" for="addImage">
            <i
              class="fa fa-4x fa-cloud-upload upload-icon"
              aria-hidden="true"
            ></i>
            <span id="uploadPhoto">
              {{ 'Employee.UploadCoverImage' | translate }}
            </span>
          </label>
          <span class="seperator">{{ 'Employee.or' | translate }}</span>
        </div>
        <div id="addCover" class="pointer" (click)="selectImage()">
          <div class="text-center">
            {{ 'Employee.ChooseFromLibrary' | translate }}
          </div>
        </div>
      </div>
      <div class="HoverImage">
        <div>
          <input
            type="file"
            id="addImage"
            accept="image/*"
            capture="camera"
            (change)="onAddImage($event)"
          />
          <label
            class="pointer small upload-cover"
            for="addImage"
            style="margin: 0px"
          >
            <div class="three-div upload-cover-pic">
              {{ 'Employee.UploadCoverImage' | translate }}
            </div>
          </label>
        </div>
        <div class="three-div" (click)="selectImage()">
          {{ 'Employee.ChooseFromLibrary' | translate }}
        </div>
        <div class="three-div-detail" *ngIf="!showError">
          <div style="display: flex; align-items: center">
            <div class="img-center">
              <img class="final-img" alt="" [src]="finalCroppedImage" />
            </div>
            <div class="name-text">{{ finalName }}</div>
            <div class="img-size">
              <i
                class="fa fa-circle"
                style="transform: scale(0.3)"
                aria-hidden="true"
              ></i>
              {{ getImageSize(currentFile) }} MB
            </div>
          </div>
          <div class="icon-two">
            <i
              class="fas fa-pen edit-icon"
              (click)="onEdit(content?.item?.Image)"
              aria-hidden="true"
            ></i>
            <i
              class="fas fa-trash-alt trash-icon"
              (click)="onRemoveImg()"
              aria-hidden="true"
            ></i>
          </div>
        </div>
      </div>
    </div>

    <h4 class="text-left prize-name">
      {{ 'PATPRIZES.PrizeName' | translate | titlecase }}
    </h4>
    <div class="display-flex-left">
      <span *ngIf="content.item.library">content.item[selectedLang].Name</span>
      <input
        type="text"
        *ngIf="!content.item.library"
        class="form-control"
        [disabled]="viewOnly"
        [(ngModel)]="content.item[selectedLang].Name"
      />
    </div>

    <h4 class="text-left prize-description">
      {{ 'PATPRIZES.PrizeDescription' | translate | titlecase }}
    </h4>
    <div class="display-flex-left">
      <span *ngIf="content.item.library">
        content.item[selectedLang].Description
      </span>
      <textarea
        type="text"
        rows="1"
        autosize
        *ngIf="!content.item.library"
        [disabled]="viewOnly"
        class="form-control autosize"
        placeholder="{{
          'OBJECTIVE_SHEET_POPUP.DescriptionPlaceHolder' | translate
        }}"
        [(ngModel)]="content.item[selectedLang].Description"
      ></textarea>
      <!-- <i
        *ngIf="
          defaultLanguage !== selectedLang && !content.item.library && !viewOnly
        "
        class="fas fa-language fa-1_5x pointer"
        tooltip="{{ 'Generic.TranslateFromDefault' | translate }}"
        placement="bottom"
        (click)="translate(content.item, selectedLang, 'Description')"
      ></i> -->
    </div>
  </div>
  <div
    class="button-container"
    *ngIf="content && !content.item.library && !viewOnly"
  >
    <button type="button" class="btns cancel-btn" (click)="onCancel()">
      {{ 'CANCEL' | translate }}
    </button>
    <button
      *ngIf="!content.item.library"
      type="button"
      class="btns save-btn"
      (click)="onSave()"
    >
      {{ 'SAVE' | translate }}
    </button>
  </div>
</div>
